<template>
  <v-app>
    <v-app-bar
      app absolute flat
      light
      :clipped-left="false"
      v-if="route !== 'reportsPrint'"
    >
      <v-toolbar-title class="headline text-uppercase">
        <span>teachers</span>
      </v-toolbar-title>
      <div class="mx-5">
      </div>
      <v-btn v-if="profile" text small class="mx-2" href="#/">Заявки</v-btn>
      <v-btn v-if="profile" text small class="mx-2" href="#/reports">Отчеты</v-btn>
      <v-btn v-if="profile" text small class="mx-2" href="#/complexes">Отчет по комплексам</v-btn>
      <v-spacer></v-spacer>
      <v-progress-circular v-if="inAction" indeterminate size="20" color="secondary" class="mx-3"></v-progress-circular>
      <v-card flat light class="py-1 px-2 darkligth" v-if="profile">
        {{profile.fullname}}
        <v-icon small>vpn_key</v-icon>
        {{profile.position ? profile.position.schoolid : null}}
      </v-card>
      <v-btn color="secondary" text v-if="(ready === true) && !profile" href="#/login">Войти</v-btn>
      <v-btn color="secondary" text v-if="profile" @click="$store.dispatch('logout')" icon>
        <v-icon>logout</v-icon>
      </v-btn>
    </v-app-bar>
    <v-content app>
      <router-view/>
    </v-content>
    <snackbars></snackbars>
    <Confirmation></Confirmation>
  </v-app>
</template>

<script>
import Snackbars from '@/components/Snackbars'
import Confirmation from '@/components/Confirmation'
export default {
  name: 'App',
  data: () => ({}),
  components: { Snackbars, Confirmation },
  computed: {
    ready () {
      return this.$store.state.ready
    },
    profile () {
      return this.$store.state.profile
    },
    inAction () {
      return this.$store.state.tasksInAction > 0
    },
    route () {
      console.log()
      return this.$store.state.route.name
    }
  },
  watch: {
    ready (val) {
      if (val === true && this.profile === null) {
        this.$router.push('login')
      }
    }
  }
}
</script>
<style>
</style>
